(function(window, angular, undefined) {
    angular.module('formApp')
        .filter("capitalize", function() { // register new filter
            return function(input) {
                return (!!input) ? input.replace(/\b[a-z]/g, function(letter) { return letter.toUpperCase(); }) : undefined;
            };
        });
})(window, window.angular);

